module.exports = __webpack_public_path__ + "static/media/alert-dialog-claim-icon.0bce2b4e.png";